import { axiosApiClient, axiosFileUploadClient } from "..";
import { handleError } from "../../utils/errors";

class CertificateService {
  // Apply for certificate
  applyCertificate = async (courseId, data) => {
    try {

      const response = await axiosFileUploadClient.post(
        `/certificates/apply/${courseId}`,
        data,
      );
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom apliciranja za sertifikat");
    }
  };

  // Get user's certificate applications
  getUserApplications = async () => {
    try {
      const response = await axiosApiClient.get(
        "/certificates/my-applications",
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja zahteva za sertifikate");
    }
  };

  // Get certificate application status for a specific course
  getCertificateStatus = async (courseId) => {
    try {
      const response = await axiosApiClient.get(
        `/certificates/status/${courseId}`,
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Greška prilikom provere statusa sertifikata",
      );
    }
  };

  // Download approved certificate PDF
  downloadCertificate = async (applicationId) => {
    try {
      const response = await axiosApiClient.get(
        `/certificates/download/${applicationId}`,
        { responseType: "blob" },
      );

      // Create blob link to download file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `sertifikat-${applicationId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (err) {
      throw handleError(
        err,
        "Greška prilikom preuzimanja sertifikata",
      );
    }
  };

  // Get all applications (admin)
  getAllApplications = async (params = {}) => {
    try {
      const response = await axiosApiClient.get("/admin/certificates", {
        params,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja zahteva za sertifikate");
    }
  };

  // Approve application (admin)
  approveApplication = async (id, certificatePdf) => {
    try {
      const formData = new FormData();
      formData.append("certificatePdf", certificatePdf);

      const response = await axiosFileUploadClient.post(
        `/admin/certificates/${id}/approve`,
        formData,
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom odobravanja zahteva");
    }
  };

  // Delete application (admin)
  deleteApplication = async (id) => {
    try {
      const response = await axiosApiClient.delete(`/admin/certificates/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom brisanja zahteva");
    }
  };
}

const certificateService = new CertificateService();
export default certificateService;
